import {useCodeViewBanners} from '@github-ui/code-view-shared/contexts/CodeViewBannersContext'
/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'
import {useEffect} from 'react'

import {forceAnnouncementToScreenReaders} from '../utilities/screen-reader-announcement'

export function CodeViewContextBanners() {
  const banners = useCodeViewBanners()
  useEffect(() => {
    let messageToAnnounce = ''
    for (const banner of banners) {
      messageToAnnounce += banner.message
    }
    if (messageToAnnounce) forceAnnouncementToScreenReaders(messageToAnnounce)
  }, [banners])

  return (
    <>
      {banners.map((banner, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <Flash key={index} variant={banner.variant} className="tmp-mt-3">
          {banner.message}
        </Flash>
      ))}
    </>
  )
}
